import React from 'react';
import { CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, Theme, useTheme } from '@mui/material';
import { Procedure, ProcedureSpecialty } from 'types/procedure';
import { Specialty } from 'types/specialty';

interface ProcedureSpecialtiesFormProps {
  procedure: Procedure;
  handleChangeSpecialties(selectedIds: number[]): void;
  loadingSpecialties: boolean;
  specialties: Specialty[];
}

function getStyles(id: number, theme: Theme, personId?: readonly ProcedureSpecialty[]) {
  return {
    fontWeight: personId?.some(specialty => specialty.id === id)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const ProcedureSpecialtiesForm: React.FC<ProcedureSpecialtiesFormProps> = ({
  loadingSpecialties,
  procedure,
  handleChangeSpecialties,
  specialties,
}) => {
  const theme = useTheme();

  return (
    <Grid container size={12} spacing={2} maxWidth={600}>
      <Grid size={12}>
        <FormControl style={{ width: '100%', minWidth: 250, height: '100%' }}>
          <InputLabel>Especialidades</InputLabel>
          <Select
            label="Especialidades"
            multiple
            fullWidth
            value={procedure.specialties.filter(item => !!item.active).map(s => s.specialty_id)}
            onChange={e => handleChangeSpecialties(e.target.value as number[])}
            disabled={loadingSpecialties}
          >
            {loadingSpecialties && <CircularProgress />}
            {specialties.map(specialty => (
              <MenuItem
                key={specialty.id}
                value={specialty.id}
                style={getStyles(
                  specialty.id,
                  theme,
                  procedure.specialties.filter(item => !!item.active),
                )}
              >
                {specialty.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ProcedureSpecialtiesForm;
